import { Box, Container } from '@material-ui/core'
import { useEffect, useMemo, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from "react-router-dom";
import CommonDialog from 'src/components/common/CommonDialog';
import FilterSection from 'src/components/common/filterSection';
import PlayerComponent from 'src/components/helperComponents/PlayerComponent'
import AddEditLanguage from 'src/components/language/AddEditLanguage'
import useQueryTable from 'src/hooks/useQueryTable'
import { DeleteCourseById, GetProducts, GetRzpPlans } from 'src/redux/actions'
import { LocalTable } from 'src/ui/Table'
import { GetCourseTableColumns } from 'src/util/columns'

const LanguageList = () => {
  const dispatch = useDispatch()
  const location = useLocation();
  const [recordToEdit, setRecordToEdit] = useState()
  const [mediaUrl, setMediaUrl] = useState()
  const [searchText, setSearchText] = useState(null)
  const [customFilterQuery, setCustomFilterQuery] = useState()

  const [{ pageIndex, pageSize }, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  })
  const products = useSelector(store => store.mainReducer.products || [])
  const rzpPlans = useSelector(store => store.mainReducer.rzpPlans?.items || [])

  // Get language list API
  const { data, isLoading, isFetching, refetch } = useQueryTable({
    name: 'courses',
    searchText: searchText,
    pageIndex: pageIndex,
    pageSize: pageSize,
    additionalFilters: customFilterQuery,
  })

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const languageId = params.get("_id");

    setCustomFilterQuery(prev => {

      const newQuery = { ...prev };

      if (languageId) {
        newQuery._id = languageId;
      } else {
        delete newQuery._id;
      }
      return newQuery;
    });
  }, [location.search]);

  // Get product list API
  useEffect(() => {
    dispatch(GetProducts())
    dispatch(GetRzpPlans())
  }, [dispatch]);

  // function for delete language api
  const onDeleteRow = async (recordToDelete) => {
    if (recordToDelete) {
      await dispatch(DeleteCourseById(recordToDelete))
      refetch()
    }
  }

  const columns = useMemo(() => GetCourseTableColumns(), []);

  return (
    <>
      <Helmet>
        <title>Courses | Langistan</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3,
        }}
      >
        <Container maxWidth={false}>

          {/* addButton filters & search section  */}
          <FilterSection
            type="Language"
            path="languages"
            setSearchText={setSearchText}
            setRecordToEdit={setRecordToEdit}
            setCustomFilterQuery={setCustomFilterQuery}
          />

          {/* language table list */}
          <Box sx={{ pt: 3 }}>
            <LocalTable
              columns={columns}
              onEditClick={setRecordToEdit}
              onDeleteClick={onDeleteRow}
              data={data}
              isLoading={isLoading}
              isFetching={isFetching}
              name="Language"
              exportApiName="courses"
              exportFileName="languages.csv"
              setPagination={setPagination}
              additionalFilters={customFilterQuery}
            />
          </Box>

          {mediaUrl && (
            <PlayerComponent
              url={mediaUrl}
              onDialogCancel={() => setMediaUrl()}
            />
          )}

          {/* Create & Update Language */}
          <CommonDialog
            open={!!recordToEdit}
            title={`${recordToEdit?.id ? "Update" : "Add New"} Language`}
            onClose={() => {
              setRecordToEdit();
            }
            }
            maxWidth="md"
          >
            <AddEditLanguage
              selectedRow={recordToEdit}
              products={products && [...products, { name: 'Free', id: 'free_product' }]}
              rzpPlans={rzpPlans && [...rzpPlans, { name: 'Free', id: 'free_product' }]}
              refetch={refetch}
              toggleDrawer={() => setRecordToEdit()}
            />
          </CommonDialog>

        </Container>
      </Box >
    </>
  )
}

export default LanguageList
